<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :applyTranslate="false"
              :isRequiredFarms="true"
              :onlyFarmsFruits="true"
              :filterOfLots="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6"
            />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="Object.keys(tableData).length > 0"
      >
        <template slot="header">
          <div class="row">
            <div
              class="col-12 col-md-5 col-lg-4"
              style="
                display: flex;
                align-items: center;
                justify-content: flex-start;
              "
            >
              <h5 class="card-title mr-4">
                {{ $t('production.plant_trimming_by_age') }}
              </h5>
              <el-checkbox class="mt-1" v-model="percentage"
                >{{ $t('common_words.value_percentual') }}?
              </el-checkbox>
            </div>
          </div>
        </template>
        <el-container>
          <aside-list
            @clickItem="handleChangeMenuSelected"
            :label="$t('common_words.farms')"
            optionIndex="byLots"
            :list="tableData.farms"
            v-if="Object.keys(tableData.clusters).length > 1"
          />
          <el-container v-if="farmData.length > 0">
            <el-main
              :style="
                Object.keys(tableData.clusters).length == 1
                  ? 'paddingLeft: 0 !important; overflow: hidden;'
                  : ''
              "
            >
              <div class="row">
                <div
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <el-select
                    clearable
                    @clear="pagination.perPage = 10"
                    class="select-default mb-3 shadow-sm"
                    style="width: 200px"
                    v-model="pagination.perPage"
                    :placeholder="$t('common_words.per_page')"
                    filterable
                  >
                    <el-option
                      class="select-default"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    clearable
                    show-word-limit
                    class="mb-3 shadow-sm"
                    style="width: 200px"
                    :placeholder="$t('common_words.search_records')"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  />
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                      <thead-ribbons :columns="farmData[2]" />
                      <tbody>
                        <tr v-for="(row, i) in queriedData">
                          <td class="text-center">
                            {{ row.name }}
                          </td>
                          <td class="text-center">
                            {{ row.area }}
                          </td>
                          <td class="text-center">
                            {{ row.ringing_reason_name }}
                          </td>
                          <td
                            class="text-center"
                            v-for="(cluster, k) in farmData[2]"
                            :key="k"
                          >
                            <template v-if="!percentage">
                              {{
                                getNumberClusters(
                                  cluster,
                                  row.ringing_reason_id,
                                  row.number_lot
                                )
                              }}
                            </template>
                            <template v-else>
                              <cell-percentage
                                :value="
                                  getNumberClusters(
                                    cluster,
                                    row.ringing_reason_id,
                                    row.number_lot
                                  )
                                "
                                :totalRow="
                                  getNumberClusters(
                                    cluster,
                                    row.ringing_reason_id,
                                    row.number_lot
                                  )
                                "
                                :totalColumn="
                                  getNumberClusters(
                                    cluster,
                                    row.ringing_reason_id,
                                    row.number_lot,
                                    'column'
                                  )
                                "
                              />
                            </template>
                          </td>
                          <td class="text-center">
                            <strong style="font-size: 16px">
                              {{
                                getTotalRow(
                                  row.ringing_reason_id,
                                  row.number_lot
                                )
                              }}
                            </strong>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td class="text-center p-3" colspan="3">
                            <strong style="font-size: 16px">{{
                              $t('common_words.total_mayus')
                            }}</strong>
                          </td>
                          <td
                            class="text-center"
                            v-for="(cluster, j) in farmData[2]"
                            :key="j"
                          >
                            <strong style="font-size: 16px">{{
                              getTotalColumn(cluster)
                            }}</strong>
                          </td>
                          <td class="text-center">
                            <strong style="font-size: 16px">{{
                              getTotal()
                            }}</strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div
                    slot="footer"
                    class="mt-3 col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <div class>
                      <p class="card-category">
                        {{ $t('table2.showing') }} {{ from + 1 }}
                        {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                        {{ total }} {{ $t('table2.entries') }}
                      </p>
                    </div>
                    <l-pagination
                      class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="pagination.total"
                      pageFirst="false"
                      pageLast="false"
                    ></l-pagination>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12" v-if="isExcel()">
                  <div class="text-center">
                    <button
                      class="btn custom-btn-success custom-shadow-btn"
                      @click="exportToExcel"
                    >
                      <em class="fa fa-file-excel-o"></em>
                      {{ $t('common_words.export_to_excel') }}
                    </button>
                  </div>
                </div>
              </div>
            </el-main>
          </el-container>
        </el-container>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { getSumOfValorFromArray } from 'src/util/Util.js';
import { mapActions } from 'vuex';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import AbbreviatedTextTooltip from 'src/components/Texts/AbbreviatedTextTooltip.vue';
import AsideList from 'src/components/Layouts/AsideList.vue';
import CellPercentage from '../CellPercentage';
import Filter from 'src/components/Filter/Filters.vue';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import PaginationTable from './Pagination';
import SweetAlert from 'src/class/Alerts';
import TheadRibbons from './TheadRibbons.vue';
import i18n from 'src/i18n';

export default {
  components: {
    [AbbreviatedTextTooltip.name]: AbbreviatedTextTooltip,
    [AsideList.name]: AsideList,
    [CellPercentage.name]: CellPercentage,
    [Filter.name]: Filter,
    [TheadRibbons.name]: TheadRibbons,
    LPagination,
  },

  computed: {
    ...PaginationTable.computed,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      activeName: 'filter',
      farmData: [],
      percentage: false,
      valueCollapse: null,
    };
  },

  mixins: [MixinExport, MixinMasters, MixinMenu, MixinPermissions],

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleChangeMenuSelected(data) {
      this.showHideLoading(true);
      this.farmData = [
        this.tableData.clusters[data.id],
        this.tableData.columns[data.id],
        this.tableData.ribbonsHead[data.id],
        this.tableData.totalRows[data.id],
        this.tableData.totalColumns[data.id],
        data.id,
      ];

      this.searchFuse(['ringing_reason_name', 'name'], this.getRows, 0.2);

      try {
        let obj = event.path[0];
        obj.classList.add('is-active');
        setTimeout(() => {
          this.showHideLoading();
        }, 20);
      } catch (error) {
        this.showHideLoading();
      }
    },

    getNumberClusters(cluster, defect, lot, type = 'row') {
      try {
        const numberCluster = getSumOfValorFromArray(
          this.farmData[0][defect][lot][
            `${cluster.edge} ${i18n.t('common_words.week_short')}`
          ][cluster.color_name].map((data) => data.number_clusters)
        );

        if (this.percentage) {
          let total = 0;
          if (type === 'row') {
            total = this.getTotalRow(defect, lot, false);
          } else if (type === 'column') {
            total = getSumOfValorFromArray(
              this.farmData[4][
                `${cluster.edge} ${i18n.t('common_words.week_short')}`
              ][cluster.color_name].map((data) => {
                return Array.isArray(data)
                  ? getSumOfValorFromArray(data)
                  : data;
              })
            );
          }

          const percent = (Number(numberCluster) / Number(total)) * 100;

          return Number(percent) === 0
            ? ''
            : `${Formatter.formatNumber(percent)}%`;
        }

        return Formatter.formatNumber(numberCluster);
      } catch (error) {
        return '';
      }
    },

    getTotal() {
      if (this.queriedData.length === 0) return '';
      let total = 0;
      const rows = [];
      Object.values(this.farmData[3]).forEach((totalColumns) => {
        Object.values(totalColumns).forEach((row) => rows.push(row));
      });

      const result = this.queriedData
        .map((item) => item.index)
        .map((index) => rows[index]);

      result.forEach((row) => {
        total += getSumOfValorFromArray(row);
      });

      return total > 0 ? Formatter.formatNumber(total) : '';
    },

    getTotalRow(defect, lot, format = true) {
      const total = getSumOfValorFromArray(this.farmData[3][defect][lot]);
      return format ? Formatter.formatNumber(total) : total;
    },

    getTotalColumn(cluster, format = true) {
      const result = this.queriedData
        .map((item) => item.index)
        .map((index) => {
          const filtered =
            this.farmData[4][`${cluster.edge} Sem`][cluster.color_name][index];
          return Array.isArray(filtered)
            ? getSumOfValorFromArray(filtered)
            : filtered;
        });
      const sum = getSumOfValorFromArray(result);
      return sum > 0 ? (format ? Formatter.formatNumber(sum) : sum) : '';
    },

    handleFilter(data) {
      this.dataFilter = { ...data };
      this.loadRingingJournalReport();
    },

    loadRingingJournalReport() {
      this.showHideLoading(true);
      this.farmData = [];
      this.tableData = [];
      this.dataFilter.route = 'ringings/journals/ringingreports';

      Axios.postMasters(this.dataFilter)
        .then((response) => {
          if (
            response.data &&
            Object.keys(response.data.data.clusters).length == 0
          ) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
            this.tableData = [];
          } else {
            this.tableData = response.data.data;
            setTimeout(() => {
              const keys = Object.keys(this.tableData.clusters);
              if (keys.length == 1) {
                this.handleChangeMenuSelected({ id: keys[0] });
              } else {
                document
                  .getElementsByClassName(
                    'el-menu-item custom-el-menu-item-cal'
                  )[0]
                  .click();
              }
            }, 100);
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    exportToExcel() {
      this.Excel(
        {
          route: 'ringings/journals/ringingreports/excel/',
          name_file: 'repique_edades_defectos.xlsx',
          farm: [this.farmData[5]],
          bySel: this.dataFilter.bySel,
          datei: this.dataFilter.datei,
          datef: this.dataFilter.datef,
          percentage: this.percentage,
        },
        'POST',
        true
      )
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
  },

  mounted() {
    this.selectedItemOnMenu('ringings');
  },

  destroyed() {
    this.deselectedItemOnMenu('ringings');
  },
};
</script>
<style>
.card .table:not(.not-last-td) tbody td:last-child,
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}
</style>
